module.exports = __webpack_public_path__ + "img/hair_stylist.2913733a.png";